<template>
  <div class="bg">
    <v-nav></v-nav>
    <mode class="modeapp" v-if="loadMode"></mode>
    <div class="downpage">
      <div class="databox" v-show="down1.bookList.length>0||down1.audioList.length>0||down1.videoList.length">
        <div class="title">心密资料下载</div>
        <div class="data_main">
          <div class="data_list">
            <div class="data_tab_group">
              <div class="data_tab" v-if="down1.bookList.length>0" :class="{'select':select==0}" @click="selectFile(0)">文字</div>
              <div class="data_tab" v-if="down1.audioList.length>0" :class="{'select':select==1}" @click="selectFile(1)">音频</div>
              <div class="data_tab"  v-if="down1.videoList.length>0" :class="{'select':select==2}" @click="selectFile(2)">视频</div>
            </div>
            <div class="data">
              <div class="file docfile" v-if="select==0">
                <div class="item" v-for="item in down1.bookList">
                  <div class="filename textover">《{{item.className}}》</div>
                  <div class="down" @click="downFile(item)">下载</div>
                </div>
              </div>
              <div class="file audiofile" v-if="select==1">
                <div class="item"  v-for="item in down1.audioList">
                  <div class="filename textover">《{{item.className}}》</div>
                  <div class="down" @click="downFile(item)">下载</div>
                </div>
              </div>
              <div class="file videofile" v-if="select==2">
                <div class="item" v-for="item in down1.videoList">
                  <div class="filename textover">《{{item.className}}》</div>
                  <div class="down"  @click="downFile(item)">下载</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="databox" v-show="down2.bookList.length>0||down2.audioList.length>0||down2.videoList.length">
        <div class="title ">其它资料下载</div>
        <div class="data_main">
          <div class="data_list">
            <div class="data_tab_group">
              <div class="data_tab" v-if="down2.bookList.length>0" :class="{'select':otherFile.select==0}" @click="otherSelectFile(0)">文字</div>
              <div class="data_tab" v-if="down2.audioList.length>0" :class="{'select':otherFile.select==1}" @click="otherSelectFile(1)">音频</div>
              <div class="data_tab" v-if="down2.videoList.length>0" :class="{'select':otherFile.select==2}" @click="otherSelectFile(2)">视频</div>
            </div>
            <div class="data">
              <div class="file docfile" v-if="otherFile.select==0">
                <div class="item" v-for="item in down2.bookList">
                  <div class="filename textover">《{{item.className}}》</div>
                  <div class="down"  @click="downFile(item)">下载</div>
                </div>

              </div>
              <div class="file audiofile" v-if="otherFile.select==1">
                <div class="item" v-for="item in down2.audioList">
                  <div class="filename textover">《{{item.className}}》</div>
                  <div class="down"  @click="downFile(item)">下载</div>
                </div>
              </div>
              <div class="file videofile" v-if="otherFile.select==2">
                <div class="item" v-for="items in down2.videoList">
                  <div class="filename textover" >《{{items.className}}》</div>
                  <div class="down" @click="downFile(items)">下载</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="down_title">佛法修证心要APP下载</div>
      <div class="android_down">点击按钮直接下载“佛法修证心要”安卓版</div>
      <div class="down_btn" @click="downloadApp">立即下载</div>
      <!--<div class="" @click="testDown">下载test</div>-->
      <div class="android_down ios_down">打开App Store搜索“佛法修证心要”下载</div>
    </div>
  </div>
</template>

<script>
  import mode from '@/components/bg/mode'
  import download from '../../../static/down'
    export default {
        name: "download",
        components:{
          mode
        },
        data() {
            return {
              select:0,
              otherFile:{
                select:0
              },
              down1:{
                bookList:[],
                audioList:[],
                videoList:[]
              },
              down2:{
                bookList:[],
                audioList:[],
                videoList:[]
              },
              fileArr:['txt','pdf','doc','docx'],
              audioArr:['mp3','cda','wav','aif','mid','wma','ra'],
              videoArr:['avi','mov','rmvb','rm','flv','mp4','3gp'],
              loadMode:true,
              //currentUrl:'http://sys.hljsyxjs.net/static/package/ffxzxy.apk'
              currentUrl:'http://sys.ffxzxy.com/static/package/ffxzxy.apk'
            }
        },
        mounted() {
          this.getDownData()
        },
        methods: {
          // testDown(item){
          //   download(1, 'http://qn61.ping360.cn/4a61ff9146f743e16d2895c13187af2a.pdf', 'aaf')
          // },
          async downloadApp(){
            // download(1, this.currentUrl, '佛法修正心要')
            this.$layer.msg("正在下载,请稍后",{icon:1});//提示框
            // let response = await fetch(this.currentUrl); // 内容转变成blob地址
            // let blob = await response.blob();  // 创建隐藏的可下载链接
            // let objectUrl = window.URL.createObjectURL(blob);
            var ua = navigator.userAgent.toLocaleLowerCase();
            if((ua.match(/MicroMessenger/i)=="micromessenger")||(ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null)) {
              download(1, this.currentUrl, '佛法修正心要')
            }else{
              let a = document.createElement('a');
              a.href = this.currentUrl;
              a.target='_self'
              a.download ='佛法修正心要';
              a.click()
              a.remove();
              // this.$layer.msg("文件下载成功",{icon:1});
            }


          },
          getDownData(){
            this.loadMode=true
            this.$http({
              url: '/dense/heart',
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              data: {ajax:1}
            }).then((res) => {
              this.getOtherData()
              console.log(res)
              if(res.data.code==0){
                res.data.data.map((item,index,arr)=>{
                  console.log(item)
                  var index= item.pdf_content.lastIndexOf(".");
                  console.log(index)
                  var ext = item.pdf_content.substr(index+1);
                  console.log(ext)
                  if(this.fileArr.indexOf(ext)>=0){
                    this.down1.bookList.push(item)
                  }
                  if(this.audioArr.indexOf(ext)>=0){
                    this.down1.audioList.push(item)
                  }
                  if(this.videoArr.indexOf(ext)>=0){
                    this.down1.videoList.push(item)
                  }
                })
                if(this.down1.audioList.length>0){
                  this.select=1
                  console.log(22222)
                }else if(this.down1.videoList.length>0){
                  this.select=2
                }else{
                  this.select=0
                }
                console.log(this.down1)
              }else{
                // this.$layer.msg(res.data.msg)
              }
            })
              .catch((error) => {
                // error
                this.$layer.msg('网络错误，请稍后重试')
                this.loadMode=false
                console.log(error)
              })
          },
          getOtherData(){
            this.$http({
              url: '/dense/other',
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              data: {ajax:1}
            }).then((res) => {
              this.loadMode=false
              console.log(res)
              if(res.data.code==0){
                res.data.data.map((item,index,arr)=>{
                  console.log(item)
                  var index= item.pdf_content.lastIndexOf(".");
                  console.log(index)
                  var ext = item.pdf_content.substr(index+1);
                  console.log(ext)
                  if(this.fileArr.indexOf(ext)>=0){
                    this.down2.bookList.push(item)
                  }
                  if(this.audioArr.indexOf(ext)>=0){
                    this.down2.audioList.push(item)
                  }
                  if(this.videoArr.indexOf(ext)>=0){
                    this.down2.videoList.push(item)
                  }
                })
                if(this.down2.audioList.length>0){
                  this.otherFile.select=1
                }else if(this.down2.videoList.length>0){
                  this.otherFile.select=2
                }else{
                  this.otherFile.select=0
                }
                console.log(this.down2)
              }else{
                // this.$layer.msg(res.data.msg)
              }
            })
              .catch((error) => {
                // error
                this.$layer.msg('网络错误，请稍后重试')
                this.loadMode=false
                console.log(error)
              })
          },
          downFile(item){
            console.log(item)
            this.$layer.msg("文件较大,请稍后",{icon:1});
            download(1, item.pdf_content, item.className,1)
            // this.$nextTick(()=>{
            //   var ua = navigator.userAgent.toLowerCase();
            //   if(ua.match(/MicroMessenger/i)=="micromessenger") {
            //     this.$layer.msg('请点击右上角……,选择其它浏览器下载')
            //     return false
            //   }
            // })
            // this.$layer.msg("文件下载中,请稍后",{icon:1});//提示框
            // let response = await fetch(item.pdf_content); // 内容转变成blob地址
            // console.log(response)
            // let blob = await response.blob();  // 创建隐藏的可下载链接
            // let objectUrl = window.URL.createObjectURL(blob);
            // let a = document.createElement('a');
            // a.href = objectUrl;
            // a.download = item.className;
            // a.click()
            // a.remove();
            // this.$layer.msg("文件下载成功",{icon:1});
          },
          selectFile(type){
            this.select=type
            console.log(this.select)
          },
          otherSelectFile(type){
            this.otherFile.select=type
          }
        },

    }
</script>

<style scoped lang="scss">
  .bg{
    background: url("../../assets/images/phone/downbg.jpg")no-repeat left bottom;
    position: fixed;
    top:0;
    min-height: 100%;
    left:0;
    right:0;
    bottom:0;
    background-size:100% 100%;
    overflow: auto;
  }
  .downpage{
    padding-bottom:1rem;
    .databox{
      .title{
        padding:0.35rem 0.3rem;
        box-sizing: border-box;
        font-size:0.32rem;
        color:#5f4009;
      }
      .data_main{
        padding:0 0.3rem;
        box-sizing: border-box;
        width:100%;
        overflow-y: auto;
        .data_list{
          border-radius:6px;
          background:rgba(201,161,104,0.2);
          .data_tab_group{
            display: flex;
            .data_tab{
              flex:1;
              text-align: center;
              padding:0.25rem 0 0.2rem;
              font-size:0.28rem;
              color:#5f4009;
            }
            .select{
              border-bottom:1px solid #5f4009;
            }
          }
          .data{
            max-height:5.78rem;
            padding-bottom:0.3rem;
            overflow-y: auto;
            .item{
              padding:0 0.25rem;
              box-sizing: border-box;
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-top:0.3rem;
              .filename{
                font-size:0.28rem;
                color:#5f4009;
                padding-left:0.47rem;
                box-sizing: border-box;
                width:80%;
              }
              .down{
                font-size:0.28rem;
                color:#5f4009;
                border-bottom:1px solid #5f4009;
                padding:0.1rem;
              }
            }
          }
          .docfile{
            .filename{
              background:url("../../assets/images/phone/book.png")no-repeat left center;
              background-size:0.22rem auto;
            }
          }
          .audiofile{
            .filename{
              background:url("../../assets/images/audio.png")no-repeat left center;
              background-size:0.22rem auto;
            }
          }
          .videofile{
            .filename{
              background:url("../../assets/images/video.png")no-repeat left center;
              background-size:0.22rem auto;
            }
          }
        }
      }
    }
    .down_title{
      text-align: center;
      font-size:0.42rem;
      color:#5f4009;
      /*letter-spacing: 0.06rem;*/
      padding:0.5rem 0;

    }
    .android_down{
      background: url("../../assets/images/android.png")no-repeat left center;
      background-size:0.28rem auto;
      color:#5f4009;
      font-size:0.28rem;
      width:6.05rem;
      margin:0 auto;
      padding:0 0 0 0.4rem;
      box-sizing: border-box;
    }
    .down_btn{
      width:6.05rem;
      margin:0.38rem auto 0.5rem;
      height:1rem;
      background:#5f4009;
      border-radius:4px;
      color:#fff;
      text-align: center;
      line-height: 1rem;
      font-size:0.28rem;
    }
    .ios_down{
      background: url("../../assets/images/ios.png")no-repeat left center;
      background-size:0.28rem auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/m/download.vue